import { Link, useLocation } from 'react-router'

import { cn } from '@/lib/cn'

import { isNavItemActive, NAV_ITEMS } from './navigation'

/** The phone counterpart to the sidebar. Hidden from md: upwards. */
export function TabBar() {
  const { pathname } = useLocation()

  return (
    <nav
      aria-label="Primary"
      className="flex h-tabbar items-stretch border-t border-border md:hidden"
    >
      {NAV_ITEMS.map((item) => (
        <Link
          key={item.to}
          to={item.to}
          aria-current={isNavItemActive(item, pathname) ? 'page' : undefined}
          className={cn(
            'relative flex flex-1 flex-col items-center justify-center gap-1 transition-colors',
            isNavItemActive(item, pathname) ? 'text-accent' : 'text-text-muted',
          )}
        >
          <span className="relative">
            <item.icon className="h-5 w-5" aria-hidden="true" />
          </span>
          <span className="text-[0.6875rem] font-medium leading-none">{item.label}</span>
        </Link>
      ))}
    </nav>
  )
}
